import type { SiteSettings } from '@lambda/shared/types';

const CACHE_KEY = 'bhg-public-site-settings-v1';

/** How long cached registration flags are trusted before revalidating. */
export const PUBLIC_SITE_SETTINGS_CACHE_MAX_AGE_MS = 10 * 60 * 1000;

interface CachedPublicSiteSettings {
  settings: SiteSettings;
  fetchedAt: number;
}

export function readPublicSiteSettingsCache(): SiteSettings | null {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CachedPublicSiteSettings;
    if (!parsed?.settings || typeof parsed.fetchedAt !== 'number') return null;
    if (Date.now() - parsed.fetchedAt > PUBLIC_SITE_SETTINGS_CACHE_MAX_AGE_MS) {
      sessionStorage.removeItem(CACHE_KEY);
      return null;
    }
    return parsed.settings;
  } catch {
    return null;
  }
}

export function writePublicSiteSettingsCache(settings: SiteSettings): void {
  try {
    const payload: CachedPublicSiteSettings = {
      settings,
      fetchedAt: Date.now(),
    };
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(payload));
  } catch {
    // Private mode / quota — ignore
  }
}

